// frontend/src/pages/AboutProject.js

import React from 'react';

const AboutProject = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-heading text-primary mb-4">
        Über das Projekt
      </h1>
      <p className="text-gray-700 leading-relaxed">
        Auf dieser Website schreiben wir über Sachen die uns als Klasse interessieren,
        über unser Dorf bis hin zu wichtigen Themen wie den Menschenrechten. Unser Ziel
        mit dem Projekt ist es junge Leute zu informieren und herauszufinden, wie man
        Artikel schreibt. Ausserdem sind wir auch auf Plattformen der Sozialen Medien
        Plattformen wie Instagram und TikTok zu finden. Tipps für das journalistische
        Arbeiten erhalten wir von Fachleuten und Medienexperten, welche uns in der Schule
        besuchen. Wir nehmen zudem an Führungen in verschiedenen Medienhäusern teil und
        sammeln die Informationen, die wir brauchen.
      </p>
    </div>
  );
};

export default AboutProject;
